export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/worker.624e7998.worker.js");
}
